<template>
<div class="giftcard-cont">
<div class="gift-top">
  <div class="gift-col"><img src="../../../public/image/locations/giftCardsStacked2.png"></div>
  <div class="gift-col">
    <h1>Give the gift of Turkish Restaurant</h1>
    <p>With Turkish Restaurant gift cards, friends and family can order Turkish food anytime from their favorite Turkish restaurants</p>
    <div class="claim-button" @click="clickBuyGift">Buy a Digital Gift Card</div>
  </div>
</div>
<div class="gift-bottom">
  <div class="gift-col">
    <div class="gift-col-top"><i class="fas fa-gifts"></i></div>
    <div class="gift-col-bottom">
      For birthdays, holidays, or "just because," a Turkish Restaurant gift card complements any occasion or celebration.
    </div>
  </div>
  <div class="gift-col">
    <div class="gift-col-top"><i class="fas fa-thumbs-up"></i></div>
    <div class="gift-col-bottom">
      Available in a digital format, each Turkish Restaurant gift card is easy to redeem at checkout.
    </div>
  </div>
  <div class="gift-col">
    <div class="gift-col-top"><i class="fas fa-calendar-times"></i></div>
    <div class="gift-col-bottom">
      Turkish Restaurant gift cards never expire, and can be used to order something delicious on our website.
    </div>
  </div>
</div>
</div>
</template>

<script>
export default {
  metaInfo () {
    return {
      title: 'Gift Cards',
      titleTemplate: '%s',
      meta: [
        {
          vmid: 'description',
          name: 'description',
          content: 'Turkish Restaurant is a unique portal where you can find the most delicious traditional Turkish dishes of the United States.'
        }
      ]
    }
  },
  methods: {
    clickBuyGift () {
      this.$router.push('buy-gift-card')
    }
  }
}
</script>
<style lang="scss">
.giftcard-cont{
  padding:0 20px;
}
 .gift-top{
  display:flex;
  align-items: center;
  font-size:16px;
 }
 .gift-col{
  h1, p {
    margin-bottom:15px;
  }
 }
 .gift-bottom {
  margin-top:50px;
  display:flex;
  .gift-col {
    text-align: center;
    font-size:16px;
    padding:10px;
    i {
      font-size:62px;
      color:#0070eb;
    }
    .gift-col-top{
      margin-bottom:20px;
    }
  }
 }
 @media (max-width:768px){
  .gift-top{
    flex-direction: column;
    .gift-col img {
      max-width: 100%;
    }
    h1{
      font-size:18px;
    }
    p {
      font-size:15px;
    }
  }
  .gift-bottom {
    flex-direction: column;
  }
  .claim-button{
    width:100%;
    text-align:center;
  }
 }
</style>
